import React, { useState, useEffect } from "react";

import { servicePost } from "../../helper/api";
import MultiSelect from "../Account/components/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  setResidentailServices,
  setResidentailSpeciality,
} from "../../redux/features/servicesSlice";

const ResidentialDrawer = ({ onHide, serviceTitle, data }) => {
  const [selectedResServices, setSelectedResServices] = useState([]);
  const [selectedSpecaility, setSelectedSpecaility] = useState([]);
  const [residentailServiceData, setResidentailServiceData] = useState([]);
  const [residentailSpecailityData, setResidentailSpecailityData] = useState(
    []
  );

  const allServices = useSelector((state) => state.allServices);
  const selectedResidentailServices = allServices?.selectedResidentailServices;
  const selectedResidentailSpeciality =
    allServices?.selectedResidentailSpeciality;

  console.log("allServices", allServices);
  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const dispatch = useDispatch();

  // get Residentail Service Data
  const getResidentailServceData = async () => {
    try {
      const residentailServiceRes = await servicePost(
        "adminbooking/getIndustryData",
        {},
        notification,
        authToken
      );

      // Filter out the data where name is "Specialty Cleaning"
      const filteredData = residentailServiceRes.data.filter(
        (item) => item.name !== "Specialty Cleaning"
      );

      setResidentailServiceData(filteredData);
    } catch (error) {
      console.log("err", error);
    }
  };

  // get Residentail Service Data
  const getResidentailSpecialityData = async () => {
    try {
      const residentailSpecailityRes = await servicePost(
        "adminbooking/getspecialServiceData",
        {
          industry: "Specialty Cleaning",
        },
        notification,
        authToken
      );
      setResidentailSpecailityData(residentailSpecailityRes.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    getResidentailServceData();
    getResidentailSpecialityData();
  }, []);

  // Initialize the selected services and specialties from props data
  useEffect(() => {
    setSelectedResServices(
      residentailServiceData.filter((service) =>
        selectedResidentailServices.some(
          (selectedService) => selectedService.name === service.name
        )
      )
    );
    setSelectedSpecaility(
      residentailSpecailityData.filter((speciality) =>
        selectedResidentailSpeciality.some(
          (selectedSpeciality) => selectedSpeciality.name === speciality.name
        )
      )
    );
  }, [data, residentailServiceData, residentailSpecailityData]);

  // // Handle Commercial Select Services and Spacility
  // const handleChange = (event, type, id, name) => {
  //   const { checked } = event.target;
  //   if (type === "services") {
  //     if (checked) {
  //       setSelectedResServices([...selectedResServices, { id, name }]);
  //     } else {
  //       setSelectedResServices(
  //         selectedResServices.filter((service) => service.id !== id)
  //       );
  //     }
  //   } else if (type === "speciality") {
  //     if (checked) {
  //       setSelectedSpecaility([...selectedSpecaility, { id, name }]);
  //     } else {
  //       setSelectedSpecaility(
  //         selectedSpecaility.filter((speciality) => speciality.id !== id)
  //       );
  //     }
  //   }
  // };

  //   // Dispatch changes when selectedComServices or selectedSpecaility changes
  //   useEffect(() => {
  //     dispatch(setResidentailServices(selectedResServices));
  //     dispatch(setResidentailSpeciality(selectedSpecaility));
  //   }, [selectedResServices, selectedSpecaility, dispatch]);

  // Handle Commercial Select Services and Speciality
  const handleChange = (event, type, id, name) => {
    const { checked } = event.target;

    if (type === "services") {
      if (checked) {
        setSelectedResServices((prevSelected) => [
          ...prevSelected,
          { id, name },
        ]);
      } else {
        setSelectedResServices((prevSelected) =>
          prevSelected.filter((service) => service.name !== name)
        );
      }
    } else if (type === "speciality") {
      if (checked) {
        setSelectedSpecaility((prevSelected) => [
          ...prevSelected,
          { id, name },
        ]);
      } else {
        setSelectedSpecaility((prevSelected) =>
          prevSelected.filter((speciality) => speciality.name !== name)
        );
      }
    }
  };

  // Dispatch changes when selectedComServices or selectedSpecaility changes
  useEffect(() => {
    if (selectedResServices.length > 0 || selectedSpecaility.length > 0) {
      dispatch(setResidentailServices(selectedResServices));
      dispatch(setResidentailSpeciality(selectedSpecaility));
    }
  }, [selectedResServices, selectedSpecaility, dispatch]);

  useEffect(() => {
    const accordionItems = document.querySelectorAll("[data-accordion-item]");
    accordionItems.forEach((item, index) => {
      const button = item.querySelector(".accordion-button");
      const collapse = item.querySelector(".accordion-collapse");

      if (index === 0) {
        item.classList.add("active");
        collapse.classList.add("show");
      }

      collapse.addEventListener("show.bs.collapse", function () {
        item.classList.add("active");
      });

      collapse.addEventListener("hide.bs.collapse", function () {
        item.classList.remove("active");
      });
    });
  }, []);

  return (
    <div className="service-drawer-main-wrapper profile-service-drawer-wrapper">
      <div className="service-drawer-main-wrap">
        <div className="service-drawer-header profile-service-drawer-header">
          <div className="service-drawer-head-left">
            <h3> Services </h3>
            <p>
              If you are applying for these plans, please contact us via email
              at
              <span> example@example.com</span> or phone at (123) 456-7890.
            </p>
          </div>

          <div className="drawer-close-icon-wrap">
            <img
              onClick={() => onHide()}
              src="./images/icons/close-icon.svg"
              alt="icon"
            />
          </div>
        </div>
        <div className="signup-special-services-wrap">
          <div className="specail-service-commerical-wrapper">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item" data-accordion-item>
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    <img src="./images/icons/residental-icon.png" alt="icon" />
                    Residental
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse" // Ensure 'collapse' class is present
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="commerical-services-wrap">
                      <h4>Services</h4>
                      <div className="commerical-services-select-wrap">
                        <MultiSelect
                          items={residentailServiceData}
                          selectedItems={selectedResServices}
                          handleChange={handleChange}
                          itemType="services"
                        />
                      </div>
                    </div>

                    <div className="commerical-services-wrap commerical-specility-wrap">
                      <h4>Speciality</h4>
                      <div className="commerical-speciality-select-wrap">
                        <MultiSelect
                          items={residentailSpecailityData}
                          selectedItems={selectedSpecaility}
                          handleChange={handleChange}
                          itemType="speciality"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResidentialDrawer;
